'use client';

import { useEffect, useMemo, useRef, type DependencyList, type ReactNode } from 'react';

import { usePageActionsSlotContext } from './PageActionsSlot';

export const usePageActions = (factory: () => ReactNode, deps: DependencyList): void => {
  const { register, unregister } = usePageActionsSlotContext();
  const idRef = useRef<symbol | null>(null);
  if (idRef.current === null) {
    idRef.current = Symbol('pageActions');
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const node = useMemo(factory, deps);

  useEffect(() => {
    const id = idRef.current!;
    register(id, node);
  }, [node, register]);

  useEffect(() => {
    const id = idRef.current!;
    return () => {
      unregister(id);
    };
  }, [unregister]);
};
